var h = () => ({
  extraImages: /* @__PURE__ */ new Map(),
  controller: new AbortController(),
  init() {
    document.body.addEventListener("add-bundle-image", (t) => {
      t instanceof CustomEvent && "key" in t.detail && "image" in t.detail && this.registerImage(t.detail.key, t.detail.image);
    }, { signal: this.controller.signal });
  },
  get otherImages() {
    return Array.from(this.extraImages.values()).filter(c("id"));
  },
  destroy() {
    this.controller.abort();
  },
  registerImage(t, e) {
    e === null ? this.extraImages.delete(t) : this.extraImages.set(t, e);
  },
  getPageSize(t) {
    return parseInt(getComputedStyle(t).getPropertyValue("--perpage") || "1");
  }
}), u = () => ({
  thumbAtStart: !0,
  thumbAtEnd: !0,
  thumbOverflow: !1,
  init() {
    this.$nextTick(() => {
      this.thumbUpdate();
      const t = new ResizeObserver(() => this.thumbUpdate());
      t.observe(this.$refs.thumbStrip);
      const e = this.$slider?.components.get("gallery")?.querySelector("img");
      e && t.observe(e);
    });
  },
  thumbUpdate() {
    const t = this.$refs.thumbStrip;
    if (!t) return;
    const e = getComputedStyle(this.$root).flexDirection === "column", r = this.$slider?.components.get("gallery")?.querySelector("img"), i = e && r?.clientHeight ? r.clientHeight + "px" : "";
    this.$root.style.maxHeight !== i && (this.$root.style.maxHeight = i);
    const s = t.scrollHeight > t.clientHeight + 1, n = this.thumbOverflow;
    if (this.thumbOverflow = s || t.scrollWidth > t.clientWidth + 1, n && !this.thumbOverflow) {
      const l = document.activeElement;
      l?.closest("[data-thumb-arrow]") && this.$root.contains(l) && t.querySelector("button[aria-current], button")?.focus();
    }
    const o = s ? t.scrollTop : t.scrollLeft, a = s ? t.scrollHeight - t.clientHeight : t.scrollWidth - t.clientWidth;
    this.thumbAtStart = o <= 1, this.thumbAtEnd = o >= a - 1;
  },
  thumbScroll(t) {
    const e = this.$refs.thumbStrip, r = e.scrollHeight > e.clientHeight + 1, i = (r ? e.clientHeight : e.clientWidth) * 0.8 * t, s = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    e.scrollBy({
      top: r ? i : 0,
      left: r ? 0 : i,
      behavior: s ? "auto" : "smooth"
    });
  }
}), c = (t) => {
  const e = /* @__PURE__ */ new Set();
  return (r) => e.has(r[t]) ? !1 : (e.add(r[t]), !0);
};
export {
  h as ProductGallery,
  u as ProductGalleryThumbnails
};
